/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/camera'
export default icon
